import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { ClickOutsideModule } from '../../directive/click-outside/click-outside.module';
import { LifeObserveModule } from '../../directive/life-observe/life-observe.module';
import { LoadingModule } from '../../directive/loading/loading.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CustomizeFormModule } from '../customize-form/customize-form.module';
import { EmptyModule } from '../empty/empty.module';
import { LedPopupModule } from '../led-popup/led-popup.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { CurrencyWalletExpansionComponent } from './currency-wallet-expansion.component';

@NgModule({
  imports: [
    CommonModule,
    LifeObserveModule,
    EmptyModule,
    LoadingModule,
    ScrollbarModule,
    PipesModule,
    MatCheckboxModule,
    FormsModule,
    CustomizeFormModule,
    ClickOutsideModule,
    MatTabsModule,
    MatRadioModule,
    MatSlideToggleModule,
    OverlayModule,
    LedPopupModule,
  ],
  declarations: [CurrencyWalletExpansionComponent],
  exports: [CurrencyWalletExpansionComponent],
})
export class CurrencyWalletExpansionModule {}
